var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"title":"土地托管统计"}},[_c('div',{staticClass:"landSta"},[_c('div',{staticClass:"landSta-top"},[_c('TopLeft'),_c('TopRight')],1),_c('div',{staticClass:"landSta-bottom"},[_c('BottomLeft'),_c('BottomCenter'),_c('BottomRight')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }